import { render, staticRenderFns } from "./LmLanguageSelector.vue?vue&type=template&id=32a9af3c"
import script from "./LmLanguageSelector.vue?vue&type=script&lang=js"
export * from "./LmLanguageSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports